import React, { useEffect, useRef } from 'react';

interface ConfirmDialogueCompProps {
  show: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;

}

const ConfirmDialogueComp: React.FC<ConfirmDialogueCompProps> = ({ show, title = "Confirm", message, onConfirm, onCancel, }) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const bsModalRef = useRef<any>(null);
  useEffect(() => {
    if (modalRef.current) {
      bsModalRef.current = new (window as any).bootstrap.Modal(modalRef.current);
      modalRef.current.addEventListener('hidden.bs.modal', onCancel);
    }
    return () => {
      modalRef.current?.removeEventListener('hidden.bs.modal', onCancel);
    };
  }, []);

  useEffect(() => {
          if (show) {
              
              bsModalRef.current?.show();
          } else {
              bsModalRef.current?.hide();
          }
      }, [show]);

  return (
    <div className="modal fade" tabIndex={-1} ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-0">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={() => bsModalRef.current?.hide()}></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer d-flex justify-content-between">
            <button className="btn btn-outline-dark rounded-0" onClick={onCancel}>No</button>
            <button className="btn btn-danger rounded-0" onClick={onConfirm}>Yes</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmDialogueComp;